import React from 'react';
import { motion } from 'framer-motion';
import globe from "../assets/images/globe.png";
import line from "../assets/images/dotline.png";

const sentence = "Our expertise has garnered the trust of multiple businesses and individuals across the globe";

export default function HowItWorks() {
    // Split the sentence into words for animation
    const words = sentence.split(" ");

    return (
        <section className="px-[10%] py-[6%]">
            <header className="flex items-center justify-center gap-3 flex-wrap">
                <img src={globe} alt="globe-icon" className="globe-icon w-[25px] h-[25px]" />

                {/* Word-by-word animation */}
                <motion.h2
                    className="uppercase text-[.9rem] font-normal text-[#7B8695] text-center flex flex-wrap"
                >
                    {words.map((word, index) => (
                        <motion.span
                            key={index}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            viewport={{ once: false, amount: 0.5 }}
                            className="mr-1"
                        >
                            {word}
                        </motion.span>
                    ))}
                </motion.h2>
            </header>

            <h3 className='text-center text-[1.6rem] font-bold text-[var(--primary-color)] leading-[6]'>How it works</h3>

            <div className='grid lg:grid-cols-5 md:grid-cols-1 sm:grid-cols-1 justify-center gap-3'>

                {/* Step 1 */}
                <motion.div
                    className="text-center flex flex-col justify-center items-center gap-[5px] px-[20px] py-[10px]"
                    initial={{ x: -100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ type: "spring", delay: 0.2 }}
                    viewport={{ once: false }}
                >
                    <div className='point w-[30px] h-[30px] text-lg rounded-full bg-[var(--primary-color)] leading-[1.68] text-[var(--second-primary-color)]'>1</div>
                    <h4 className='text-[1.4rem] text-[var(--primary-color)] font-[800]'>Register</h4>
                    <p className='text-[#555D68] text-[1rem] leading-[1.4] w-[400] p-2'>Register yourself as a Fastest user</p>
                </motion.div>

                <div className='flex flex-col items-center pt-10 pb-10'>
                    <img src={line} alt="" className='w-auto h-auto' />
                </div>

                {/* Step 2 */}
                <motion.div
                    className="text-center flex flex-col justify-center items-center gap-[5px] px-[20px] py-[10px]"
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ type: "spring", delay: 0.4 }}
                    viewport={{ once: false }}
                >
                    <div className='w-[30px] h-[30px] text-lg rounded-full bg-[var(--primary-color)] leading-[1.68] text-[var(--second-primary-color)]'>2</div>
                    <h4 className='text-[1.4rem] text-[var(--primary-color)] font-[800]'>Verify your Identity</h4>
                    <p className='text-[#555D68] text-[1rem] leading-[1.4] w-[400] p-2'>Our process is simple and easy</p>
                </motion.div>

                <div className='flex flex-col items-center pt-10 pb-10'>
                    <img src={line} alt="" className='w-auto h-auto' />
                </div>

                {/* Step 3 */}
                <motion.div
                    className="text-center flex flex-col justify-center items-center gap-[5px] px-[20px] py-[10px]"
                    initial={{ x: -100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ type: "spring", delay: 0.6 }}
                    viewport={{ once: false }}
                >
                    <div className='w-[30px] h-[30px] text-lg rounded-full bg-[var(--primary-color)] leading-[1.68] text-[var(--second-primary-color)]'>3</div>
                    <h4 className='text-[1.4rem] text-[var(--primary-color)] font-[800]'>Success</h4>
                    <p className='text-[#555D68] text-[1rem] leading-[1.4] w-[400] p-2'>You can use Fastest and all its facilities</p>
                </motion.div>

            </div>
        </section>
    );
}
